import Text from '$tablet-app/src/app/components/Text';
import React, { FC } from 'react';
import styled from 'styled-components/native';

const CalendarDayNoEvents: FC = () => {
  const noEventsText = 'There are no events today.';
  const encouragementText =
    'Create an event by tapping the + Create event button.';

  const imgSource = require('../../../../../assets/calendar_icon.png');

  return (
    <NoEventsView>
      <CalendarImgView>
        <CalendarImage source={imgSource} />
      </CalendarImgView>
      <NoEventsText>{noEventsText}</NoEventsText>
      <Text variant="h3">{encouragementText}</Text>
    </NoEventsView>
  );
};

const calendarImgBgColor = '#F5F7F9';
const baseImgWidthToHeightRatio = 244 / 212;
const calendarImgHeight = 150;
const calendarImgWidth = calendarImgHeight * baseImgWidthToHeightRatio;
const circleBgPadding = 20;
const circleBgPaddingLeft = circleBgPadding * 1.7;
const circleBgPaddingRight = circleBgPadding * 0.3;
const circleBgPaddingTop = circleBgPadding * baseImgWidthToHeightRatio * 1.5;
const circleBgPaddingBottom = circleBgPadding * baseImgWidthToHeightRatio * 0.5;

const borderRadius = (calendarImgWidth + circleBgPadding * 2) / 2;

const NoEventsView = styled.View`
  align-items: center;
  justify-content: center;
  margin-top: 80px;
`;

const CalendarImgView = styled.View`
  background-color: ${calendarImgBgColor};
  padding-left: ${circleBgPaddingLeft}px;
  padding-right: ${circleBgPaddingRight}px;
  padding-top: ${circleBgPaddingTop}px;
  padding-bottom: ${circleBgPaddingBottom}px;
  border-radius: ${borderRadius}px;
`;

const CalendarImage = styled.Image`
  width: ${calendarImgWidth}px;
  height: ${calendarImgHeight}px;
`;

const NoEventsText = styled(Text)`
  margin: 15px;
  font-size: 28px;
`;

export default CalendarDayNoEvents;
